import {
  TOGGLE_SHOW_MORE_ACTIVITY,
  SET_ACTIVITY_FILTER,
  SET_ACTIVITY_SEARCH_TERM,
  SET_ACTIVITY_TYPE,
  SET_PAGINATION_SIZE,
  SET_PAGINATION_PAGE
} from 'actions'

const initialState = {
  isShowingMoreActivity: false,
  filter: '',
  search: '',
  type: 'all',
  paginationSize: 25,
  paginationPage: 1
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case TOGGLE_SHOW_MORE_ACTIVITY:
      return {
        ...state,
        isShowingMoreActivity: !state.isShowingMoreActivity
      }
    case SET_ACTIVITY_FILTER:
      return {
        ...state,
        paginationPage: 1,
        filter: payload
      }
    case SET_ACTIVITY_SEARCH_TERM:
      return {
        ...state,
        paginationPage: 1,
        search: payload
      }
    case SET_ACTIVITY_TYPE:
      return {
        ...state,
        paginationPage: 1,
        type: payload
      }
    case SET_PAGINATION_SIZE:
      return {
        ...state,
        paginationPage: 1,
        paginationSize: payload
      }
    case SET_PAGINATION_PAGE:
      return {
        ...state,
        paginationPage: payload
      }
    default:
      return state
  }
}
